import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

type barChartProps = {
  title: string;
  yTitle: string;
  xCategories: string[];
  seriesName: string;
  seriesData: { name: string, data: [number | undefined] }[];
}

export default function BarChart(props: barChartProps) {
  const chartOptions: Highcharts.Options = {
    chart: {
      type: 'column'
    },
    title: {
      text: props.title
    },
    xAxis: {
      categories: props.xCategories,
      crosshair: true
    },
    yAxis: {
      min: 0,
      title: {
        text: props.yTitle
      }
    },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0
      }
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px">{point.key}</span><table>',
      pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
        '<td style="padding:0"><b>{point.y}</b></td></tr>',
      footerFormat: '</table>',
      shared: true,
      useHTML: true
    },
    credits: {
      enabled: false
    },
    //@ts-ignore
    series: props.seriesData,
    legend: {
      enabled: false
    }

  }
  return (<>
    <HighchartsReact
      highcharts={Highcharts}
      options={chartOptions}
    />
  </>)
}